import { render, staticRenderFns } from "./AppointmentRequest.vue?vue&type=template&id=70383b56&"
import script from "./AppointmentRequest.vue?vue&type=script&lang=js&"
export * from "./AppointmentRequest.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports